<script>
import { mapState, mapGetters } from 'vuex'
import Translate from './translate'
export default {
  data () {
    return {
      loginEmail: false,
      loading: false,
      error: '',
      form: {
        email: '',
        password: ''
      },
      fromChallenge: false
    }
  },
  computed: {
    ...mapGetters(['primaryColorRgb', 'activeSubscription']),
    ...mapState(['home', 'settings', 'selectedOrder', 'locale'])
  },
  components: {
    Translate
  },
  created () {
    if (this.$router.history.current.name === 'Challenge') {
      this.fromChallenge = true
    } else { this.fromChallenge = false }
  },
  methods: {
    async submit (evt) {
      evt.preventDefault()
      this.error = ''
      this.loading = true
      const response = await this.$store.dispatch('login', this.form)
      if (response && response.data && response.data.success) {
        const user = response.data.user

        window.Leanplum.setUserId(user._id)
        if (window.ga) {
          window.ga('set', 'userId', user._id)
        }
        window.Leanplum.setUserAttributes({
          _id: user._id,
          name: user.profile.name,
          email: user.email,
          trainer_id: user.trainer_id,
          'Preferred Language': this.locale
        })

        window.Leanplum.track('User', { action: 'sign_in', source: 'gateway' })
        // Logged in
        this.$bvModal.hide('modal-login')
        if (this.fromChallenge && !this.activeSubscription && !this.selectedOrder.plan) {
          // Do something different
          this.$bvModal.show('modal-challenge-purchase')
        } else {
          this.$store.dispatch('startSession', { token: user.token, prices: [this.selectedOrder.plan, this.selectedOrder.sku] })
        }
      } else {
        this.error = (response && response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again later.'
        this.loading = false
      }
    },
    toggleEmailSignIn () {
      this.loginEmail = !this.loginEmail
    },
    closeModal () {
      this.$root.$emit('bv::hide::modal', 'modal-login')
    }
  }
}
</script>

<template>
  <div :class="['container--sign-up', { error: error }]" :style="{ '--BGColor': `rgba(${primaryColorRgb}, ${1})` }">
     <div :class="['row header', { error: error }]">
      <div class="col-5 message">{{error}}</div>
      <div class="col action">
        <BaseButton @click="$bvModal.hide('modal-login');$bvModal.show('modal-forgotpw');" class="button sign-in-email">
            <Translate directive="modal.login.resetpassword" />
        </BaseButton>
      </div>
      <div @click="closeModal" class="col close">&times;</div>
    </div>
      <div class="signUpButtons text-center" v-show="!loginEmail">
        <p class="step-indicator"><Translate directive="modal.login.title" /></p>
        <h3><Translate directive="modal.login.text" /></h3>
        <BaseButton class="button sign-in-email other" :style="{'--primaryColor': settings.primaryColor ? settings.primaryColor.hex : ''}" @click="toggleEmailSignIn"><Translate directive="modal.login.button" /></BaseButton><br />
      </div>
      <div class="container--signup-form" v-show="loginEmail">
        <div class="back-button" v-if="!error" @click="toggleEmailSignIn">&#8592; <Translate directive="profile.backlabel" /></div>
        <div class="text-center">
          <p class="step-indicator"></p>
          <h3><Translate directive="modal.login.formtitle" /></h3>
        </div>
        <b-form @submit="submit">
          <b-form-group
              id="input-group-1"
              label="Email address:"
              label-for="input-1">
              <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              required
              :placeholder="this.$_polyglot.t('profile.email')"
              ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Password:" label-for="input-2">
              <b-form-input
              id="input-2"
              v-model="form.password"
              type="password"
              required
              autocomplete="on"
              :placeholder="this.$_polyglot.t('profile.password')"
              ></b-form-input>
          </b-form-group>
          <BaseButton type="submit" :disabled="loading" class="button sign-in-email" :style="{'background-color': settings.primaryColor ? settings.primaryColor.hex : '', '--button-color': settings.primaryColor ? settings.primaryColor.hex : '', '--button-hover': settings.primaryColor ? settings.primaryColor.hex : ''}"><b-spinner v-show="loading" small type="grow"></b-spinner><span v-show="!loading"><Translate directive="modal.login.formsubmit" /></span></BaseButton>
        </b-form>
        <p class="login-from-challenge"><span @click="$bvModal.hide('modal-login'); $bvModal.show('modal-signup');"><Translate directive="modal.login.newhere" /> <span :style="{ cursor: 'pointer', textDecoration: 'underline' }"><Translate directive="modal.register.signup" /> </span></span> | <span id="forgot-password-link" v-b-modal.modal-forgotpw><Translate directive="forgotpassword.title" /></span></p>
      </div>
  </div>
</template>

<style lang='scss' scoped>

  .container--sign-up {
    .header {
      background-color: transparent;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      height: 6rem;
      border-top-right-radius: 24px;
      border-top-left-radius: 24px;
      margin-right: unset;
      margin-left: unset;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      z-index: 99;
      cursor: pointer;
      .close {
        color: black;
        opacity: 1;
        width: 1rem;
        max-width: fit-content;
        margin-bottom: 5px;
        margin-right: 1.1rem;
      }
      .action {
        max-width: 35%;
        width: fit-content;
        padding-right: unset;
        padding-left: unset;
        .button {
          background: #FFFFFF;
          color: #F15555;
          margin-bottom: unset;
          max-width: unset;
          font-style: normal;
          font-weight: bold;
          font-size: 1.1rem;
          font-size: calc(0.8rem + (21 - 16) * ((100vw - 30rem) / (1600 - 300))) !important;
          padding: 0.75rem;
        }
      }
      .message {
        color: white;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 150%;
        margin-left: 2rem;
      }
      &.error {
        background: #F15555;
        .close {
          color: white;
        }
      }
    }
    &.error {
      input {
        border: 1px solid #F15555;
      }
    }
  }
  .signin-button {
    background-color: var(--primaryColor) !important;
    border-color:var(--primaryColor) !important;
  }

  .container--sign-in {
    padding: 170px 0;
    .sign-in-email {
      width: 100%;
    }
  }

  .email-login {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: var(--primaryColor);
  color: #fff;
  border-radius:8px;
  width: 100%;
  height: 40px;
  margin-top: 2.5px;
  margin-bottom: 2.5px;
  cursor: pointer;
  svg {
    margin-right: 5px;
  }
  }
  .hr {
    display: inline-block;
    border-bottom: white 1px solid;
    width: 100px;
    margin: 30px;
  }
  .sign-in-email {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 3rem;
    border-radius: 3px;
    background-color: var(--primaryColor);
    color: #fff;
    border-radius:8px;
    width: 100%;
    height: 40px;
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    cursor: pointer;
    &.other {
      background-color: var(--primaryColor) !important;
      background: var(--primaryColor) !important;
    }
    &:hover { background-color: white; color: white;}
}

@media (max-width:767px){
  .container--sign-in {
    padding: 85px 0;
  }
}

@media (max-width:415px){
  .container--sign-in {
    padding-bottom: 20px;
  }
  h3 {
    margin-bottom: 16px !important;
  }
}
</style>
